import { Faq } from "./Faq";

export function HelpPage() {
  return (
    <div className="flex justify-center">
      <Faq />
    </div>
  );
}
